/**
 * terrain — part of the German catalogue (the reference language).
 * Merged in `i18n/de.ts`; every key here must exist in `i18n/en/terrain.ts`.
 */

export const terrain = {
  /* ---------------- Gelände (terrain.ts, Quelle 'terrain') ---------------- */
  'terrain.title': 'Gelände',
  'terrain.corridor': 'Korridor',
  'terrain.corridor.aria': 'Breite des geprüften Streifens',
  'terrain.corridor.nm': '{nm} NM',
  'terrain.none': 'noch kein Geländeprofil',
  'terrain.none.short': 'kein Vorschlag',
  'terrain.kept': 'Sicherheitshöhe in Abschnitt {legs} von Hand gesetzt und deshalb nicht überschrieben.',
  'terrain.leg': '{n} {from} → {to}',
  'terrain.max': 'Gelände max. {ft} ft bei {nm} NM',
  'terrain.max.plain': 'Gelände max. {ft} ft',
  'terrain.obst': 'Hindernis {name} {ft} ft',
  'terrain.obst.min': 'Hindernis {name} ≥ {ft} ft',
  'terrain.obst.plain': 'Hindernis {ft} ft',
  'terrain.obst.plain.min': 'Hindernis ≥ {ft} ft',
  'obst.kind.chimney': 'Schornstein',
  'obst.kind.building': 'Gebäude',
  'obst.kind.wind_turbine': 'Windrad',
  'obst.kind.tower': 'Turm',
  'terrain.msa': 'Sicherheitshöhe {ft} ft',
  'terrain.rule.flat': '+1000 ft',
  'terrain.rule.mountain': '+2000 ft im Gebirge',
  'terrain.nodata': 'keine Geländedaten für diesen Abschnitt',
  'terrain.spark.aria': 'Geländeprofil Abschnitt {n}',
  'terrain.status.corridor': 'Korridor {nm} NM',
  'terrain.hint':
    'Höchstes Gelände + 1000 ft, im Gebirge + 2000 ft.',
  'terrain.field.derived': 'aus dem Gelände entlang der Strecke ({id} breit)',
  'terrain.field.elev': 'aus dem Gelände geschätzt – für diesen Platz ist keine Höhe veröffentlicht',

  /* ---------------- der Schnitt durch die ganze Strecke ---------------- */
  'terrain.chart.aria': 'Geländeschnitt der ganzen Strecke, {nm} NM, Skala bis {ft} ft',
  'terrain.head.highest': 'Höchster Punkt',
  'terrain.head.clearance': 'Abstand',
  'terrain.head.noplan': 'noch keine Höhe geplant',
  'terrain.head.conflict': 'Erster Konflikt',
  'terrain.head.conflict.at': 'Abschnitt {n}, {nm} NM',
  'terrain.legend.terrain': 'Gelände',
  'terrain.legend.planned': 'geplante Höhe',
  'terrain.legend.safe': 'Sicherheitshöhe',
  'terrain.legend.obst': 'Hindernisse',
  'terrain.col.suggest': 'Vorschlag',
  'terrain.col.planned': 'geplant',
  'terrain.planned.none': 'keine Höhe',
  'terrain.flag.low': 'unter dem Vorschlag',
  'terrain.flag.none': 'unter dem höchsten Hindernis',
  'terrain.take': 'übernehmen',
  'terrain.take.leg': 'Sicherheitshöhe {v} in Abschnitt {n} übernehmen',
  'terrain.take.all': 'Vorschlag für alle {n} Abschnitte übernehmen',
  'terrain.empty.title': 'Noch keine Strecke.',
  'terrain.empty.line': 'Zwei Punkte auf der Karte genügen – dann steht hier das Gelände unter der Strecke.',
  'terrain.error': 'Gelände gerade nicht erreichbar – wird erneut versucht.',
  'terrain.caveat':
    'Hinweis, ersetzt keine Freigabe. Vor dem Flug gegen AIP und NOTAM prüfen.',

  /* ---------------- Lufträume auf der Strecke ---------------- */
  'terrain.as.title': 'Lufträume',
  'terrain.as.leg': 'Abschnitt {n}',
  'terrain.as.class': 'Klasse {c}',
  'terrain.as.clear': 'Kein Luftraum in der geplanten Höhe geschnitten.',
  'terrain.as.show': 'auf Karte',
  'terrain.as.busy': 'wird geprüft …',
  'terrain.as.error': 'Lufträume gerade nicht erreichbar – wird erneut versucht.',

  /* Das Wort neben der Abkürzung. Die Abkürzung selbst steht auf der Karte und
     im Funk und bleibt, wie sie ist. */
  'terrain.as.R': 'Beschränkungsgebiet',
  'terrain.as.D': 'Gefahrengebiet',
  'terrain.as.P': 'Luftsperrgebiet',
  'terrain.as.CTR': 'Kontrollzone',
  'terrain.as.MCTR': 'militärische Kontrollzone',
  'terrain.as.TMA': 'Nahverkehrsbereich',
  'terrain.as.CTA': 'Kontrollbezirk',
  'terrain.as.ATZ': 'Flugplatzverkehrszone',
  'terrain.as.MATZ': 'militärische Flugplatzverkehrszone',
  'terrain.as.TMZ': 'Transponderpflicht',
  'terrain.as.RMZ': 'Funkpflicht',
  'terrain.as.TRA': 'zeitweise reserviert',
  'terrain.as.TSA': 'zeitweise gesperrt',
  'terrain.as.ALERT': 'Alarmgebiet',
  'terrain.as.WARNING': 'Warngebiet',
  'terrain.as.PROTECTED': 'Schutzgebiet',
  'terrain.as.GLIDING': 'Segelflugsektor',
  'terrain.as.SPORT': 'Luftsportgebiet',
  'terrain.as.HTZ': 'Hubschrauberverkehrszone',
  'terrain.as.TIZ': 'Verkehrsinformationszone',
  'terrain.as.TIA': 'Verkehrsinformationsgebiet',
  'terrain.as.AWY': 'Luftstraße',
  'terrain.as.ADIZ': 'Luftverteidigungszone',

  /* ---------------- Hinweise oben im Fenster ---------------- */
  'terrain.bn.clearance-none': 'Abschnitt {leg}: geplante Höhe unter dem höchsten Hindernis.',
  'terrain.bn.clearance-low': 'Abschnitt {leg}: geplante Höhe unter der vorgeschlagenen Sicherheitshöhe.',
  'terrain.bn.airspace-restricted': 'Strecke schneidet {n} Gebiet(e) mit Einschränkung.',
  'terrain.bn.airspace-controlled': 'Strecke schneidet {n} kontrollierte Lufträume in der geplanten Höhe.',
} as const;
